export default {
    // чтобы названия были локальные
    namespaced: true,

    state: {
        criteria: [],
    },
    getters: {
        criteria(state){
            return state.criteria
        },
    },
    mutations: {
        setCriteria(state, data){
            state.criteria = data
        },
    },
    actions: {
    },
}